import PropTypes from 'prop-types';
import { useState } from 'react';
import { TextField, InputAdornment, IconButton, Tooltip } from '@mui/material';
import Iconify from '../iconify';
import SvgColor from '../svg-color';
import IconSelectorModal from './IconSelectorModal';
import { getIconPath } from './iconLibrary';

// ----------------------------------------------------------------------

export default function IconSelectorField({ value, onChange, error, helperText, ...other }) {
    const [modalOpen, setModalOpen] = useState(false);

    const handleIconSelect = (iconValue) => {
        onChange(iconValue);
        setModalOpen(false);
    };

    // Determine if icon is navbar SVG or iconify
    const isNavbarIcon = value && (value.startsWith('ic_') || value === 'settings');

    return (
        <>
            <TextField
                fullWidth
                value={value || ''}
                error={error}
                helperText={helperText}
                InputProps={{
                    readOnly: true,
                    startAdornment: value && (
                        <InputAdornment position="start">
                            {isNavbarIcon ? (
                                <SvgColor src={getIconPath(value)} sx={{ width: 24, height: 24 }} />
                            ) : (
                                <Iconify icon={value} width={24} />
                            )}
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <Tooltip title="Select Icon">
                                <IconButton onClick={() => setModalOpen(true)} edge="end" size="small">
                                    <Iconify icon="eva:grid-outline" />
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    ),
                }}
                sx={{
                    '& .MuiInputBase-input': {
                        cursor: 'pointer',
                    },
                }}
                onClick={() => setModalOpen(true)}
                {...other}
            />

            <IconSelectorModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onSelect={handleIconSelect}
                selectedIcon={value}
            />
        </>
    );
}

IconSelectorField.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    helperText: PropTypes.string,
};
